<template>
  <div
    :class="show_congras ? 'page_dingzhi page_dingzhiDetail page page_limit' : 'page_dingzhi page_dingzhiDetail page'"
  >
    <!-- 定制品信息 -->
    <div class="info userDingzhi" v-if="info">
      <div class="info_t">
        <div class="info_t_l">
          <img
            :src="info.userthumb ? ($publicData.withHttpStart(info.userthumb) ? info.userthumb : imageUrl+info.userthumb)  : $publicData.defaultTouxiang"
            alt
            class="thumb"
          />
          <div class="name slh_s">{{ info.username }}</div>
        </div>
        <div class="info_t_r">
          <div class="view">浏览{{'('+info.look_num+')'}}</div>
          <div class="time">{{ info.created_at }}</div>
        </div>
      </div>
      <div class="info_nr">
        <div class="nr">
          <div class="title">商品标题:</div>
          <div class="desc">{{ info.title }}</div>
        </div>
        <div class="nr">
          <div class="title">商品类型:</div>
          <div class="desc red">{{ info.cate }}</div>
        </div>
        <div class="nr" v-if="info.price">
          <div class="title">预估价格:</div>
          <div class="desc red">{{'￥'+ info.price }}</div>
        </div>
        <div class="nr">
          <div class="title">商品描述:</div>
          <div class="desc">{{ info.content }}</div>
        </div>
        <div class="info_tu" v-if="info &&　info.attrShow.length != 0">
          <div class="title">商品图片:</div>
          <div class="tu_wrap">
            <van-image
              v-for="(image,index) in info.attrShow"
              :key="index"
              fit="contain"
              :src="imageUrl+image"
              class="tu"
              @click="zhanshitupian(info.attrShow,index)"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 商家来过 -->
    <div class="tradesman" v-if="info && info.tralook.length != 0">
      <div class="title">商家来过</div>
      <!-- 商家列表 -->
      <van-swipe :loop="false">
        <van-swipe-item v-for="(tralook,index) in info.tralookArr" :key="index">
          <ul class="arts clearfix">
            <li
              class="art f-l"
              v-for="tradesman in tralook"
              :key="tradesman.tra_id"
              @click="toTradsShop(tradesman)"
            >
              <img
                :src="tradesman.thumb ? ( $publicData.withHttpStart(tradesman.thumb) ? tradesman.thumb : imageUrl+tradesman.thumb) : $publicData.defaultTouxiang"
                alt
                class="tu"
              />
            </li>
          </ul>
        </van-swipe-item>
        <!-- <van-swipe-item>
                <ul class="arts">
                    <li class="art f-l">
                        <img :src="this.publicPath+'statics/images/temp/touxiang.png'" alt="" class="tu">
                    </li>
					<li class="art f-l">
                        <img :src="this.publicPath+'statics/images/temp/touxiang.png'" alt="" class="tu">
                    </li>
                </ul>
        </van-swipe-item>-->
      </van-swipe>
    </div>
    <!-- 报名商家 -->
    <div class="tradesman" v-if="info && info.trasignup && info.trasignup.length != 0">
      <div class="title">报名商家</div>
      <ul class="artList">
        <li class="artItem_back" v-for="(singnItem,index) in info.trasignup" :key="index">
          <div class="artItem">
            <div class="artItem_l" @click="toTradsShop(singnItem)">
              <img
                :src="singnItem.thumb ? ( $publicData.withHttpStart(singnItem.thumb) ? singnItem.thumb : imageUrl+singnItem.thumb) : $publicData.defaultTouxiang"
                alt
                class="thumb"
              />
            </div>
            <div class="artItem_r">
              <div class="name">{{singnItem.nickname}}</div>
              <div class="tags">
                <div class="tag slh_s" v-if="singnItem.auth_company">{{ singnItem.auth_company }}</div>
                <div class="tag slh_s" v-if="singnItem.skill">{{ singnItem.skill }}</div>
              </div>
            </div>
          </div>
          <div :class="'guanzhu guanzhu_no'" @click="serveClick(singnItem)">聊一聊</div>
        </li>
        <!-- <li class="artItem">
				<div class="artItem_l">
					<img :src="publicPath+'statics/images/temp/ordertu.png'" alt="" class="thumb">
				</div>
				<div class="artItem_r">
					<div class="name">勿忘初心</div>
					<div class="tags">
						<div class="tag slh_s">国家级非遗</div>
						<div class="tag slh_s">家具</div>
						<div class="tag slh_s">国家级非遗国家级非遗</div>
					</div>
				</div>
        </li>-->
      </ul>
    </div>
    <!-- 取消定制 info.status 0正常,1取消 -->
    <div class="actions" v-if="info && from_user == 1 && info.status == 0 && info.work_status == 0">
      <!-- work_status 是否找到合作商家 0/1 -->
      <div class="action" @click="usercancelFun">取消定制</div>
    </div>
    <!-- 商家可以进行报名、聊天 -->
    <div
      class="pay_action"
      v-if="is_tradesman && info.status == 0 && info.work_status == 0 && info.review_status != 0"
    >
      <div class="action more" @click="signUpFun">{{info.is_signup == 0 ? '报名定制': '报名成功'}}</div>
      <div class="action more" @click="toServe">聊一聊</div>
    </div>
    <div
      class="pay_action"
      v-if="info != null && from_user == 1 && info.is_buy==1 && pay_status != 2"
    >
      <div class="action" @click="toSettle">支付定金</div>
    </div>
    <!-- 报名成功弹层 -->
    <div class="success" v-if="show_congras">
      <div class="success_t">
        <div class="text">恭喜您，参与报名成功！</div>
      </div>
      <div class="success_b" @click="signUpSuccess">知道了</div>
    </div>
    <!-- 遮罩 -->
    <van-overlay :show="show_congras" class="overlay" />
    <!-- 大图预览 -->
    <van-image-preview
      v-model="bigTuShow"
      :start-position="bigTuIndex"
      :images="bigTuImgArr"
      @change="bigTuChange"
    ></van-image-preview>
  </div>
</template>

<script>
import router from "../../../.././router";
import { LOGOUT, LOGIN } from "../../../.././vuex/mutation_types";
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
  data() {
    return {
      imageUrl: this.$publicData.uploadImage,
      publicPath: process.env.BASE_URL,
      token: null,
      id: this.$route.query.id,
      info: null,
      pay_status: this.$route.query.pay_status, // 定金支付状态 0未支付 1支付中 2支付成功
      show_congras: false,
      is_tradesman: false, // 是否为匠人
      bigTuShow: false,
      bigTuIndex: 0,
      bigTuImgArr: null,
      from_user: this.$route.query.from_user // 1 从我的定制过来,用于判断是否显示取消定制
    };
  },
  created: function() {
    var that = this;
    if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
      var params = {
        data: {
          naviTitle: "定制详情"
        }
      };
      this.$bridge.callhandler("sdjy://navigation/style", params, data => {});
      //获取用户信息
      var memberParams = {
        data: {
          notCallLogin: 1
        }
      };
      this.$bridge.callhandler(
        "sdjy://member/memberInfo",
        memberParams,
        data => {
          if (data.code == 200) {
            this.token = data.result.token;
            this.getUserInfo();
          } else {
            this.token = "";
          }
        }
      );
      //注册方法，客户端重新进入页面刷新数据
      this.$bridge.registerhandler(
        "sdjy://common/refreshPage",
        (data, responseCallback) => {
          // alert(JSON.stringify(data));
          responseCallback(data);
        }
      );
    } else {
      // 获取列表
      this.token = this.$store.getters.token;
    }
    this.getDetail();
    if (this.token) {
      this.getUserInfo();
    }
  },
  methods: {
    getDetail() {
      var params = {
        id: this.id,
        token: this.token
      };
      this.$api.dingzhi.comunitydetail(params).then(res => {
        if (res.code == 200) {
          var info = res.result;
          // 重组商家来过 8个一组
          var result = [];
          if (info.tralook && info.tralook.length != 0) {
            for (var i = 0; i < info.tralook.length; i += 8) {
              result.push(info.tralook.slice(i, i + 8));
            }
          }
          info.tralookArr = result;
          this.info = info;
          // 调起 获取微信分享参数函数
          this.getShareData();
        }
      });
    },
    toSettle() {
      if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
        var memberParams = {
          data: {}
        };
        this.$bridge.callhandler(
          "sdjy://member/memberInfo",
          memberParams,
          data => {
            if (data.code == 200) {
              var params = {
                data: {
                  url:
                    this.$publicData.clientUrl +
                    "/dingzhi/settle?id=" +
                    this.id +
                    "&type=2"
                }
              };
              this.$bridge.callhandler(
                "sdjy://public/openNewWebView",
                params,
                data => {}
              );
            }
          }
        );
      } else {
        // 验证是否登录
        if (!this.$store.getters.token) {
          localStorage.setItem("redirect", this.$router.currentRoute.fullPath);
          this.$router.push({
            path: "/login"
            // query: {
            //     redirect: this.$router.currentRoute.fullPath
            // }
          });
          return;
        }
        this.$router.push({
          path: "/dingzhi/settle",
          query: {
            id: this.id,
            type: 2
          }
        });
      }
    },
    // 获取用户信息，是否为匠人
    getUserInfo() {
      if (!this.token) {
        return;
      }
      var params = {
        token: this.token,
        is_cloud: 0 // 0商城1云订单 ,在这里无所谓用哪个值, 为了获取用户是否为匠人角色
      };
      this.$api.user.index(params).then(res => {
        if (res.code == 200) {
          this.is_tradesman = res.result.info.userrole.is_tradesman;
        }
      });
    },
    // 商家报名
    signUpFun() {
      if (this.info.is_signup == 0) {
        var params = {
          token: this.token,
          id: this.info.id
        };
        this.$api.dingzhi.tradsignup(params).then(res => {
          if (res.code == 200) {
            this.show_congras = true;
          }
        });
      } else if (this.info.is_signup == 1) {
        this.$toast("您已报名");
        return;
      }
    },
    // 报名成功
    signUpSuccess() {
      this.show_congras = false;
      this.getDetail();
    },
    // 去商家店铺
    toTradsShop(tradesman) {
      if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
        var params = {
          data: {
            url:
              this.$publicData.clientUrl +
              "/art/detail?tradesmanId=" +
              tradesman.tra_id
          }
        };
        this.$bridge.callhandler(
          "sdjy://public/openNewWebView",
          params,
          data => {}
        );
      } else {
        this.$router.push({
          path: "/art/detail",
          query: {
            tradesmanId: tradesman.tra_id
          }
        });
      }
    },
    zhanshitupian(arr, index) {
      // this.bigTuImgArr = arr;
      this.bigTuImgArr = [];
      for (var i in arr) {
        this.bigTuImgArr.push(this.imageUrl + arr[i]);
      }
      this.bigTuIndex = index;
      this.bigTuShow = true;
    },
    // 切换大图
    bigTuChange(index) {
      this.bigTuIndex = index;
    },
    // 取消定制
    usercancelFun() {
      var params = {
        token: this.token,
        id: this.id
      };
      this.$api.dingzhi.usercancel(params).then(res => {
        if (res.code == 200) {
          this.$toast("取消成功");
          if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {};
            this.$bridge.callhandler("sdjy://public/back", params, data => {});
          } else {
            this.$router.back();
          }
        }
      });
    },
    toServe() {
      var that = this;
      if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
        var memberParams = {
          data: {}
        };
        this.$bridge.callhandler(
          "sdjy://member/memberInfo",
          memberParams,
          data => {
            if (data.code == 200) {
              this.token = data.result.token;
              var params = {
                token: this.token,
                uuid: this.goodsDetail.tradesman.uuid
              };
              that.$api.xiaoxi.userInfo(params).then(res => {
                if (res.code == 200) {
                  var tradesmanInfo = res.result;
                  // console.log('创建了与匠人的通信')
                  // that.$parent.sendMsgToTradesman('与' + that.tradesmanInfo.username + '建立了通信', that.mine.userId, that.tradesmanInfo.im_username);

                  that.toAppServe(tradesmanInfo);
                }
              });
            }
          }
        );
      } else {
        this.$router.push({
          path: "/tradesman/chat",
          query: {
            uuid: this.goodsDetail.tradesman.uuid
          }
        });
      }
    },
    toAppServe(tradesmanInfo) {
      var params = {
        data: {
          toId: tradesmanInfo.im_username,
          conversationId: tradesmanInfo.im_username,
          toAvator: this.goodsDetail.tradesman.thumb,
          toName: this.goodsDetail.tradesman.name,
          toUUID: this.goodsDetail.tradesman.uuid,
          toPhone: tradesmanInfo.tradesmans.data.phone,
          trandsmanId: tradesmanInfo.tradesmans.id
        }
      };
      this.$bridge.callhandler("sdjy://public/chat", params, data => {});
    },
    serveClick(singnItem) {
      var that = this;
      if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
        var memberParams = {
          data: {}
        };
        this.$bridge.callhandler(
          "sdjy://member/memberInfo",
          memberParams,
          data => {
            if (data.code == 200) {
              this.token = data.result.token;
              var params = {
                token: this.token,
                uuid: singnItem.tra_uuid
              };
              that.$api.xiaoxi.userInfo(params).then(res => {
                if (res.code == 200) {
                  var tradesmanInfo = res.result;
                  // console.log('创建了与匠人的通信')
                  // that.$parent.sendMsgToTradesman('与' + that.tradesmanInfo.username + '建立了通信', that.mine.userId, that.tradesmanInfo.im_username);

                  that.toAppTrademanServe(tradesmanInfo, singnItem);
                }
              });
            }
          }
        );
      } else {
        if (!this.$store.getters.token) {
          localStorage.setItem("redirect", this.$router.currentRoute.fullPath);
          this.$router.push({
            path: "/login"
          });
          return;
        }
        console.log(singnItem);
        this.$router.push({
          path: "/tradesman/chat",
          query: {
            uuid: singnItem.tra_uuid
          }
        });
        // this.$router.push({
        //     path: '/system/develop'
        // })
      }
    },
    toAppTrademanServe(tradesmanInfo, singnItem) {
      var params = {
        data: {
          toId: tradesmanInfo.im_username,
          conversationId: tradesmanInfo.im_username,
          toAvator: singnItem.thumb,
          toName: singnItem.nickname,
          toUUID: singnItem.uuid,
          toPhone: tradesmanInfo.tradesmans.data.phone,
          trandsmanId: tradesmanInfo.tradesmans.id
        }
      };
      this.$bridge.callhandler("sdjy://public/chat", params, data => {});
    },
    // 获取分享参数 -- 用于配微信分享
    getShareData() {
      const url = location.href.split("#")[0];
      console.log("url", url);
      this.$api.index
        .commonShare({
          url: url
        })
        .then(res => {
          if (res.code == 200) {
            this.shareConfig = res.result;
            // console.log('this.shareConfig', this.shareConfig)
            // console.log('this.$route', this.$route)
            this.shareFun();
          }
        });
    },
    // 分享
    shareFun() {
      var that = this;
      wx.config({
        debug: that.shareConfig.debug,
        beta: that.shareConfig.beta,
        jsApiList: that.shareConfig.jsApiList,
        appId: that.shareConfig.appId,
        nonceStr: that.shareConfig.nonceStr, // 随机串
        timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
        signature: that.shareConfig.signature // 签名
      });
      // 分享
      wx.ready(function() {
        const url = location.href.split("#")[0];
        var shareData = {
          title: that.info.title
            ? that.info.title
            : that.$publicData.shareDefaultTitleA, // 分享标题
          desc: that.info.content ? that.info.content : "", // 分享描述
          link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: that.info.attrShow
            ? that.imageUrl + that.info.attrShow[0]
            : that.$publicData.domain + that.$publicData.shareDefaultIcon, // 分享图标
          success: function() {
            // 用户确认分享后执行的回调函数
            // alert('成功')
          },
          cancel: function(e) {
            // alert(e)
            // 用户取消分享后执行的回调函数
          }
        };
        wx.updateAppMessageShareData(shareData);
        wx.updateTimelineShareData(shareData);
      });
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.artItem_back {
  display: flex;
  justify-content: space-between;
}

.guanzhu {
  margin-right: 0.53rem;
  width: 1.73rem;
  height: 0.67rem;
  background: rgba(244, 244, 244, 1);
  border-radius: 0.33rem;
  font-size: 0.35rem;
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
  line-height: 0.67rem;
}
.guanzhu.guanzhu_no {
  background: rgba(211, 68, 68, 1);
  color: rgba(255, 255, 255, 1);
}
</style>
